export default "# Partial Common Ownership\n";